import { render } from "./StickyNav.vue?vue&type=template&id=fc787c18&scoped=true"
import script from "./StickyNav.vue?vue&type=script&lang=js"
export * from "./StickyNav.vue?vue&type=script&lang=js"

import "./StickyNav.vue?vue&type=style&index=0&id=fc787c18&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc787c18"]])

export default __exports__